import React from 'react'
import PropTypes from 'prop-types'
import Columns from 'components/common/Columns/Columns'
import SizeDetails from '../SizeDetails'
import { Title } from '../SharedStyles'


const BOTAllTireSizeDetailsCartridge = ({
  tireSizes = []
}) =>
  <React.Fragment>
    <Title headline headline_narrow size="30">Available Sizes</Title>
    <Columns adaptive width="50% 50%">
      <React.Fragment>
        {
          tireSizes.map(({ diameter, sizes }) =>
            <SizeDetails
              key={ diameter }
              sizes={ sizes }
              diameter={ diameter } />
          )
        }
      </React.Fragment>
    </Columns>
  </React.Fragment>

BOTAllTireSizeDetailsCartridge.propTypes = {
  tireSizes: PropTypes.arrayOf(PropTypes.shape())
}

export default BOTAllTireSizeDetailsCartridge
